import { render, staticRenderFns } from "./WebSetting.vue?vue&type=template&id=7c54a9de&"
import script from "./WebSetting.vue?vue&type=script&lang=js&"
export * from "./WebSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports